import { render } from "./partners.vue?vue&type=template&id=61c7d8a3&scoped=true"
import script from "./partners.vue?vue&type=script&lang=js"
export * from "./partners.vue?vue&type=script&lang=js"

import "./partners.vue?vue&type=style&index=0&id=61c7d8a3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61c7d8a3"

export default script